// Storage for the impersonation session. Deliberately sessionStorage-only:
// - it never touches the admin's real token in localStorage('token'), so
//   exiting (or expiry) restores the admin session without a re-login;
// - it is per-tab, so a new tab is the admin's normal session;
// - it survives a page refresh within the tab.
import { UserProfile } from '../types/user';

const TOKEN_KEY = 'impersonation_token';
const USER_KEY = 'impersonation_user';

export const getImpersonationToken = (): string | null =>
  sessionStorage.getItem(TOKEN_KEY);

export const getImpersonationUser = (): UserProfile | null => {
  const raw = sessionStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UserProfile;
  } catch {
    return null;
  }
};

export const setImpersonationSession = (
  token: string,
  user: UserProfile,
): void => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearImpersonationSession = (): void => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

export const isImpersonating = (): boolean => getImpersonationToken() !== null;
